import React, { useState } from 'react';

import styled from '@emotion/styled';

import EditIcon from '../../../../components/Icons/EditIcon';
import { Modal } from '../../../../components/Modal/Modal';
import UpdateBusinessInfoModal from '../../../../components/Modal/ModalActions/UpdateBusinessInfoModal/UpdateBusinessInfoModal';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import { useAppSelector } from '../../../../redux/store';

const WorkHistory = () => {
  const [showModal, setShowModal] = useState(false);
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);

  return (
    <SectionInfo>
      <SectionHeader>
        <LabelArea>Business Information</LabelArea>
        <LabelButton onClick={() => setShowModal(true)}>
          <Tooltip
            content='Update Business Information'
            customIcon={<EditIcon />}
          />
        </LabelButton>
      </SectionHeader>

      <GreyArea>
        <Column>
          <Row>
            <div>Business name</div>
            <div>{businessInfo?.name}</div>
          </Row>
          <Row>
            <div>Registration number</div>
            <div>{businessInfo?.registrationNumber}</div>
          </Row>
          <Row>
            <div>Industry type</div>
            <div>{businessInfo?.industryType}</div>
          </Row>
          <Row>
            <div>Typical route</div>
            <div>{businessInfo?.typicalRoute.join(', ')}</div>
          </Row>
        </Column>
        <VerticalLine></VerticalLine>
        <Column>
          <Row>
            <div>Business email</div>
            <div>{businessInfo?.email}</div>
          </Row>
          <Row>
            <div>Phone number</div>
            <div>{businessInfo?.phoneNumber}</div>
          </Row>
          <Row>
            <div>Fleet size</div>
            <div>{businessInfo?.fleetSize}</div>
          </Row>
          <Row>
            <div>Delivery vehicle type</div>
            <div>{businessInfo?.fleetCategories.join(', ')}</div>
          </Row>
        </Column>
      </GreyArea>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <UpdateBusinessInfoModal />
      </Modal>
    </SectionInfo>
  );
};

export default WorkHistory;

const SectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 8px;

  @media (max-width: 884px) {
    background-color: white;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LabelButton = styled.div`
  display: flex;
  gap: 12px;
  cursor: pointer;

  & > div {
    border: 1px solid ${({ theme }) => theme.palette.borderColor};
    padding: 12px;
    border-radius: 8px;
    color: ${({ theme }) => theme.palette.blueColor};
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
  }

  @media (max-width: 884px) {
    display: none;
  }
`;

const GreyArea = styled.div`
  background-color: #fafafa;
  color: ${({ theme }) => theme.palette.grayTextColor};
  padding: 12px;
  grid-template-columns: 1fr 1px 1fr;
  display: grid;
  gap: 34px;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const LabelArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
`;

const VerticalLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: #d1d5db;

  @media (max-width: 884px) {
    display: none;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  & > div:last-of-type {
    font-weight: 600;
    text-align: right;
  }

  @media (max-width: 884px) {
    gap: 16px;
  }
`;
